export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-thumbnail-960-d90fae3030dd5514b912537f029e7486.webp";